import { activityHistoryFiltersSlice } from "../../slice";

export const { addCustomFilters } = activityHistoryFiltersSlice.actions;
